var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3797.333 2293.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-90 11970.855 2263.495) scale(11667.5)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79d2ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373c9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-90 12810.915 1411.768) scale(11667.5)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79d2ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373c9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-90 12717.575 1516.775) scale(11667.5)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79d2ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373c9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-90 12239.207 1983.475) scale(11667.5)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79d2ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373c9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-90 14047.67 186.68) scale(11667.5)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79d2ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373c9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-90 12390.885 1843.465) scale(11667.5)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79d2ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373c9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -11667.5 11667.5 0 9800.7 14234.35)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79d2ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373c9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-90 12099.198 2123.485) scale(11667.5)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79d2ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373c9c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10903.7 11906.1h570.6v570.7h-570.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10942.1 11575.4V10667h908.4v908.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9665.44 12271.9h269.3v269.3h-269.3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10543.7 11786.6h-597.94v-597.9h597.94z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9891.74 12908.6h169.46v169.4h-169.46z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15880.9 7868.07h-1980.8v2727.43c0 91.5-74.2 165.7-165.7 165.7h-653.3V9948h640.3v-761.08h-640.3V7868.07h-954v3021.63c0 349.4 283.2 632.6 632.6 632.6h1689.7c223.5 0 404.7-181.2 404.7-404.7V8681.28h1026.8zm-2017 4868.53c-922.2 0-1748.5-410.5-2306.2-1058.7h395.2v-1113.3h-1004.1c-82-275.5-126.3-567.28-126.3-869.43 0-1679.71 1361.7-3041.37 3041.4-3041.37s3041.4 1361.66 3041.4 3041.37c0 1679.73-1361.7 3041.43-3041.4 3041.43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9624.99 13042.4h169.44v169.4h-169.44z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10748.8 12890.2h-410.2V12480h410.2z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#100f0d",
    d: "M1040.078 1521.352h-137.37v50.759h123.836v48.039H902.708v87.304h-58.197v-236.847h195.567v50.745m218.232 6.093v180.01h-45.339l-5.076-22.68c-11.504 9.48-21.654 15.573-30.112 18.28-8.459 3.04-21.316 4.4-38.233 4.4h-18.61c-41.616 0-58.873-16.92-58.873-58.88v-121.13h55.152v111.651c0 17.933 5.413 23.36 23.344 23.36h17.257c15.227 0 26.73-3.387 35.188-9.814l10.49-8.12v-117.077h54.812m174.588 0c41.612 0 58.865 16.92 58.865 58.879v121.13h-55.146V1595.79c0-17.932-5.413-23.346-23.346-23.346h-17.253c-15.226 0-26.732 3.387-35.199 9.813l-10.48 8.12v117.077h-54.818v-180.009h45.339l5.08 22.667c11.506-9.467 21.652-15.56 30.106-18.6 8.466-2.707 21.32-4.067 38.239-4.067h18.613m232.1 0c41.613 0 58.866 16.92 58.866 58.879v121.13h-55.146V1595.79c0-17.932-5.413-23.346-23.346-23.346h-17.253c-15.226 0-26.732 3.387-35.199 9.813l-10.48 8.12v117.077h-54.812v-180.009h45.333l5.08 22.667c11.506-9.467 21.652-15.56 30.105-18.6 8.467-2.707 21.32-4.067 38.24-4.067h18.612m146.49 65.985h88.651v-3.386c0-17.933-5.746-23.346-23.68-23.346h-41.278c-17.933 0-23.693 5.413-23.693 23.346zm82.558-65.985c41.626 0 58.879 16.92 58.879 58.879v40.266h-141.437v14.88c0 17.932 5.76 23.345 23.693 23.345h46.012c13.866 0 18.946-5.066 18.946-18.946v-4.733h52.786v15.56c0 35.185-15.907 50.758-50.76 50.758h-86.61c-41.613 0-58.879-16.92-58.879-58.878v-62.252c0-41.959 17.266-58.879 58.879-58.879h78.491m152.33 128.57h127.223v51.44h-185.422v-236.848h58.199v185.409m268.646 7.453c17.933 0 23.68-5.413 23.68-23.346v-45.346c0-17.933-5.747-23.346-23.68-23.346h-42.639c-17.933 0-23.68 5.413-23.68 23.346v45.346c0 17.933 5.747 23.346 23.68 23.346zm-62.252 43.985c-41.625 0-58.878-16.92-58.878-58.878v-62.252c0-41.959 17.253-58.879 58.878-58.879h81.878c41.613 0 58.865 16.92 58.865 58.879v62.252c0 41.959-17.252 58.878-58.865 58.878h-81.878m293.006-43.985c17.933 0 23.68-5.413 23.68-23.346v-45.346c0-17.933-5.747-23.346-23.68-23.346h-42.639c-17.932 0-23.679 5.413-23.679 23.346v45.346c0 17.933 5.747 23.346 23.68 23.346zm-62.265 43.985c-41.612 0-58.865-16.92-58.865-58.878v-62.252c0-41.959 17.253-58.879 58.865-58.879h81.878c41.626 0 58.879 16.92 58.879 58.879v62.252c0 41.959-17.253 58.878-58.879 58.878h-81.878m319.406-112.677c0-17.933-5.414-23.346-23.346-23.346h-20.64c-15.573 0-27.413 3.04-35.2 9.48l-10.479 8.12v56.838l10.48 8.12c8.466 6.426 19.973 9.48 35.199 9.48h20.64c17.932 0 23.346-5.413 23.346-23.346zm-3.72-67.332c41.612 0 58.865 16.92 58.865 58.879v62.252c0 41.959-17.253 58.878-58.865 58.878h-22c-15.906 0-28.08-1.36-36.546-3.72-8.453-2.373-17.586-7.453-27.399-15.573v73.425h-54.812v-234.14h45.332l5.08 22.666c11.507-9.467 21.653-15.56 30.106-18.6 8.467-2.707 21.32-4.067 38.24-4.067h21.999"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.13333 0 0 -.13333 0 2293.333)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M15880.9 7868.07h-1980.8v2727.43c0 91.5-74.2 165.7-165.7 165.7h-653.3V9948h640.3v-761.08h-640.3V7868.07h-954v3021.63c0 349.4 283.2 632.6 632.6 632.6h1689.7c223.5 0 404.7-181.2 404.7-404.7V8681.28h1026.8zm-2017 4868.53c-922.2 0-1748.5-410.5-2306.2-1058.7h395.2v-1113.3h-1004.1c-82-275.5-126.3-567.28-126.3-869.43 0-1679.71 1361.7-3041.37 3041.4-3041.37s3041.4 1361.66 3041.4 3041.37c0 1679.73-1361.7 3041.43-3041.4 3041.43"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(.13333 0 0 -.13333 0 2293.333)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M10942.1 11575.4V10667h908.4v908.4h-908.4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(.13333 0 0 -.13333 0 2293.333)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M10903.7 11906.1h570.6v570.7h-570.6v-570.7"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "matrix(.13333 0 0 -.13333 0 2293.333)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M10543.7 11786.6h-597.94v-597.9h597.94v597.9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(.13333 0 0 -.13333 0 2293.333)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M10748.8 12890.2h-410.2V12480h410.2v410.2"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(.13333 0 0 -.13333 0 2293.333)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M9665.44 12271.9h269.3v269.3h-269.3v-269.3"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "matrix(.13333 0 0 -.13333 0 2293.333)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M9891.74 12908.6h169.46v169.4h-169.46v-169.4"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "matrix(.13333 0 0 -.13333 0 2293.333)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M9624.99 13042.4h169.44v169.4h-169.44v-169.4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3567a37bac177dcdf0611f54121ad96b.svg";
export { ForwardRef as ReactComponent };